<template>
  <div class="text-xs-center">
    <v-menu
      bottom
      offset-y
      :open-on-hover="!openOnClick"
      nudge-left="60"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          class="ma-0"
          v-on="on"
        >
          <v-icon color="grey">
            more_vert
          </v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <div
          v-for="(item, i) in list"
          :key="i"
        >
          <v-list-tile
            class="grey--text text--darken-2"
            :disabled="updateDisabled(item)"
            @click="updateDisabled(item) ? null : apply(item.name)"
          >
            <v-list-tile-title class="list-line">
              <v-icon
                v-if="item.type === 'icon'"
                color="grey darken-2"
                :disabled="updateDisabled(item)"
                small
              >
                {{ item.icon }}
              </v-icon>
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile>
          <v-divider
            v-if="list.indexOf(item) !== list.length - 1"
            horizontal
          />
        </div>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  props: ["value", "list", "openOnClick", "index", "lastIndex"],
  methods: {
    apply(value) {
      this.$emit(value, this.value);
    },
    updateDisabled(item) {
      return (
        item.disabled ||
        (item.icon === "arrow_upward" && this.index === 0) ||
        (item.icon === "arrow_downward" && this.index === this.lastIndex)
      );
    },
  },
};
</script>
<style>
.list-line {
  height: 28px;
  cursor: pointer;
}
</style>
